import {
  Automation,
  mockExecuteInsightAutomationOperationMutation,
  mockInsightAutomationsQueryOperationQuery,
} from '__generated__';
import { delay, HttpResponse } from 'msw';

export const mockAutomations: Automation[] = [
  {
    __typename: 'Automation',
    id: 'automation-3',
    playbookId: 'playbook-3',
    name: 'CISCO UMbrella Investigate DIF',
    description:
      'File Reputation, Vulnerability Search, Domain Reputation, Malware Search, IP Reputation, Get Alert Details, URL Reputation, File Reputation V2, Domain Reputation 2',
    cseResourceType: 'INSIGHT',
    cseResourceSubTypes: [],
    executionTypes: ['NEW_INSIGHT', 'INSIGHT_CLOSED', 'ON_DEMAND'],
    created: '0000',
    lastUpdated: '0000',
    createdBy: 'Renee Dennis',
    lastUpdatedBy: 'Renee Dennis',
    enabled: true,
  },
  {
    __typename: 'Automation',
    id: 'automation-4',
    playbookId: 'playbook-4',
    name: 'URLscan.io Essential',
    description:
      'This is an essential playbook used to enrich incidents with URLscan.io. The playbook will collect the desired URL and launch three different enrichment actions using URLscan.',
    cseResourceType: 'INSIGHT',
    cseResourceSubTypes: [],
    executionTypes: ['NEW_INSIGHT'],
    created: '0000',
    lastUpdated: '0000',
    createdBy: 'Renee Dennis',
    lastUpdatedBy: 'Renee Dennis',
    enabled: false,
  },
];

export const handlers = [
  // READ INSIGHT AUTOMATIONS
  mockInsightAutomationsQueryOperationQuery(
    async ({ query: _query, variables: _variables }) => {
      await delay(1500);
      return HttpResponse.json({
        data: {
          __typename: 'Query',
          automations: {
            __typename: 'AutomationPage',
            objects: mockAutomations,
          },
        },
      });
    }
  ),

  // EXECUTE INSIGHT AUTOMATION
  mockExecuteInsightAutomationOperationMutation(
    async ({ query: _query, variables: _variables }) => {
      await delay(1500);
      return HttpResponse.json({
        data: {
          __typename: 'Mutation',
          executeAutomation: {
            __typename: 'ExecuteAutomation',
            executionIds: ['1234'],
          },
        },
      });
    }
  ),
];
